export default class CTAViewState {
  playing!: boolean;
  ctrlCurrentTime!: number;
  hoverMode!: boolean;
  useDash!: boolean;
  ctaContainerClassName!: string;
  CTAAutoPlayButton!: boolean;
  viewportPauseOption!: boolean;
  ctaImage!: boolean;
}